import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { getAuthToken } from "@sdk/auth";
import { CountryCode } from "@sdk/gqlTypes/globalTypes";
import * as CheckoutMutations from "@sdk/mutations/checkout";
import * as CheckoutQueries from "@sdk/queries/checkout";
import * as ShopQueries from "@sdk/queries/shop";
import { filterNotEmptyArrayItems } from "@sdk/utils";
import pick from "lodash/pick";
export var NetworkManager = function NetworkManager(client, languageCode) {
  var _this = this;

  _classCallCheck(this, NetworkManager);

  this.getCheckout =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(checkoutToken) {
      var checkout;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return new Promise(function (resolve, reject) {
                if (_this.isLoggedIn()) {
                  var observable = _this.client.watchQuery({
                    fetchPolicy: "network-only",
                    query: CheckoutQueries.userCheckoutDetails,
                    variables: {
                      languageCode: _this.languageCode
                    }
                  });

                  observable.subscribe(function (result) {
                    var data = result.data,
                        errors = result.errors;

                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                      reject(errors);
                    } else {
                      var _data$me;

                      resolve((_data$me = data.me) === null || _data$me === void 0 ? void 0 : _data$me.checkout);
                    }
                  }, function (error) {
                    reject(error);
                  });
                } else if (checkoutToken) {
                  var _observable = _this.client.watchQuery({
                    fetchPolicy: "network-only",
                    query: CheckoutQueries.checkoutDetails,
                    variables: {
                      languageCode: _this.languageCode,
                      token: checkoutToken
                    }
                  });

                  _observable.subscribe(function (result) {
                    var data = result.data,
                        errors = result.errors;

                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                      reject(errors);
                    } else {
                      resolve(data.checkout);
                    }
                  }, function (error) {
                    reject(error);
                  });
                } else {
                  resolve(null);
                }
              });

            case 3:
              checkout = _context.sent;

              if (!checkout) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", {
                data: _this.constructCheckoutModel(checkout)
              });

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                error: _context.t0
              });

            case 11:
              return _context.abrupt("return", {});

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.getRefreshedCheckoutLines =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(checkoutlines) {
      var linesWithMissingVariants, idsOfMissingVariants, linesWithProperVariants, variants, observable, linesWithMissingVariantUpdated, linesWithProperVariantUpdated;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (checkoutlines) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", {
                data: []
              });

            case 2:
              linesWithMissingVariants = [];
              idsOfMissingVariants = [];
              linesWithProperVariants = [];
              checkoutlines.forEach(function (line) {
                if (line.variant && line.totalPrice) {
                  linesWithProperVariants.push(line);
                } else {
                  idsOfMissingVariants.push(line.variant.id);
                  linesWithMissingVariants.push(line);
                }
              });

              if (!(idsOfMissingVariants && idsOfMissingVariants.length)) {
                _context2.next = 17;
                break;
              }

              _context2.prev = 7;
              observable = _this.client.watchQuery({
                query: CheckoutQueries.checkoutProductVariants,
                variables: {
                  ids: idsOfMissingVariants,
                  languageCode: _this.languageCode
                }
              });
              _context2.next = 11;
              return new Promise(function (resolve, reject) {
                observable.subscribe(function (result) {
                  var data = result.data,
                      errors = result.errors;

                  if (errors === null || errors === void 0 ? void 0 : errors.length) {
                    reject(errors);
                  } else {
                    resolve(data.productVariants);
                  }
                }, function (error) {
                  reject(error);
                });
              });

            case 11:
              variants = _context2.sent;
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](7);
              return _context2.abrupt("return", {
                error: _context2.t0
              });

            case 17:
              linesWithMissingVariantUpdated = linesWithMissingVariants.map(function (line) {
                var _variants, _variant$node$pricing;

                var variant = (_variants = variants) === null || _variants === void 0 ? void 0 : _variants.edges.find(function (edge) {
                  return edge.node.id === line.variant.id;
                });
                var variantPricing = variant === null || variant === void 0 ? void 0 : (_variant$node$pricing = variant.node.pricing) === null || _variant$node$pricing === void 0 ? void 0 : _variant$node$pricing.price;
                var totalPrice = variantPricing ? {
                  gross: _objectSpread({}, variantPricing.gross, {
                    amount: variantPricing.gross.amount * (line.quantity || 0)
                  }),
                  net: _objectSpread({}, variantPricing.net, {
                    amount: variantPricing.net.amount * (line.quantity || 0)
                  })
                } : null;
                return {
                  id: line.id,
                  productAttributes: line.productAttributes,
                  quantity: line.quantity || 0,
                  totalPrice: totalPrice,
                  variant: {
                    attributes: variant.node.attributes,
                    id: variant.node.id,
                    isAvailable: variant.node.isAvailable,
                    name: variant.node.name,
                    pricing: variant.node.pricing,
                    product: variant.node.product,
                    quantityAvailable: variant.node.quantityAvailable,
                    sku: variant.node.sku
                  }
                };
              });
              linesWithProperVariantUpdated = linesWithProperVariants.map(function (line) {
                var _line$variant$pricing;

                var variantPricing = (_line$variant$pricing = line.variant.pricing) === null || _line$variant$pricing === void 0 ? void 0 : _line$variant$pricing.price;
                var totalPrice = variantPricing ? {
                  gross: _objectSpread({}, variantPricing.gross, {
                    amount: variantPricing.gross.amount * line.quantity
                  }),
                  net: _objectSpread({}, variantPricing.net, {
                    amount: variantPricing.net.amount * line.quantity
                  })
                } : null;
                return {
                  id: line.id,
                  productAttributes: line.productAttributes,
                  quantity: line.quantity,
                  totalPrice: totalPrice,
                  variant: line.variant
                };
              });
              return _context2.abrupt("return", {
                data: [].concat(_toConsumableArray(linesWithMissingVariantUpdated), _toConsumableArray(linesWithProperVariantUpdated))
              });

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 14]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.getPaymentGateways =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var paymentGateways;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return new Promise(function (resolve, reject) {
              var observable = _this.client.watchQuery({
                fetchPolicy: "network-only",
                query: ShopQueries.getShopPaymentGateways
              });

              observable.subscribe(function (result) {
                var data = result.data,
                    errors = result.errors;

                if (errors === null || errors === void 0 ? void 0 : errors.length) {
                  reject(errors);
                } else {
                  resolve(data.shop.availablePaymentGateways);
                }
              }, function (error) {
                reject(error);
              });
            });

          case 3:
            paymentGateways = _context3.sent;

            if (!paymentGateways) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", {
              data: paymentGateways
            });

          case 6:
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", {
              error: _context3.t0
            });

          case 11:
            return _context3.abrupt("return", {});

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  this.createCheckout =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(email, lines, shippingAddress, billingAddress) {
      var _billingAddress$count, _shippingAddress$coun, _data$checkoutCreate, _data$checkoutCreate3, variables, _ref5, data, errors, _data$checkoutCreate2;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              variables = {
                checkoutInput: {
                  billingAddress: billingAddress && {
                    city: billingAddress.city,
                    companyName: billingAddress.companyName,
                    country: CountryCode[billingAddress === null || billingAddress === void 0 ? void 0 : (_billingAddress$count = billingAddress.country) === null || _billingAddress$count === void 0 ? void 0 : _billingAddress$count.code],
                    countryArea: billingAddress.countryArea,
                    firstName: billingAddress.firstName,
                    lastName: billingAddress.lastName,
                    phone: billingAddress.phone,
                    postalCode: billingAddress.postalCode,
                    streetAddress1: billingAddress.streetAddress1,
                    streetAddress2: billingAddress.streetAddress2,
                    vatNumber: billingAddress.vatNumber
                  },
                  email: email,
                  lines: lines,
                  shippingAddress: shippingAddress && {
                    city: shippingAddress.city,
                    companyName: shippingAddress.companyName,
                    country: CountryCode[shippingAddress === null || shippingAddress === void 0 ? void 0 : (_shippingAddress$coun = shippingAddress.country) === null || _shippingAddress$coun === void 0 ? void 0 : _shippingAddress$coun.code],
                    countryArea: shippingAddress.countryArea,
                    firstName: shippingAddress.firstName,
                    lastName: shippingAddress.lastName,
                    phone: shippingAddress.phone,
                    postalCode: shippingAddress.postalCode,
                    streetAddress1: shippingAddress.streetAddress1,
                    streetAddress2: shippingAddress.streetAddress2,
                    vatNumber: shippingAddress.vatNumber
                  }
                }
              };
              _context4.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.createCheckoutMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref5 = _context4.sent;
              data = _ref5.data;
              errors = _ref5.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutCreate = data.checkoutCreate) === null || _data$checkoutCreate === void 0 ? void 0 : _data$checkoutCreate.errors.length)) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutCreate2 = data.checkoutCreate) === null || _data$checkoutCreate2 === void 0 ? void 0 : _data$checkoutCreate2.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutCreate3 = data.checkoutCreate) === null || _data$checkoutCreate3 === void 0 ? void 0 : _data$checkoutCreate3.checkout)) {
                _context4.next = 13;
                break;
              }

              return _context4.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutCreate.checkout)
              });

            case 13:
              _context4.next = 18;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", {
                error: _context4.t0
              });

            case 18:
              return _context4.abrupt("return", {});

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 15]]);
    }));

    return function (_x3, _x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.setCartItem =
  /*#__PURE__*/
  function () {
    var _ref6 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(checkout) {
      var checkoutId, lines, alteredLines, _data$checkoutLinesUp, _data$checkoutLinesUp3, _ref7, data, errors, _data$checkoutLinesUp2;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              checkoutId = checkout.id;
              lines = checkout.lines;

              if (!(checkoutId && lines)) {
                _context5.next = 21;
                break;
              }

              alteredLines = lines.map(function (line) {
                var _line$productAttribut;

                return {
                  productAttributes: (_line$productAttribut = line.productAttributes) === null || _line$productAttribut === void 0 ? void 0 : _line$productAttribut.map(function (attr) {
                    return pick(attr, ["attributeId", "values"]);
                  }),
                  quantity: line.quantity,
                  variantId: line.variant.id
                };
              });
              _context5.prev = 4;
              _context5.next = 7;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutLineMutation,
                variables: {
                  checkoutId: checkoutId,
                  languageCode: _this.languageCode,
                  lines: alteredLines
                }
              });

            case 7:
              _ref7 = _context5.sent;
              data = _ref7.data;
              errors = _ref7.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context5.next = 12;
                break;
              }

              return _context5.abrupt("return", {
                error: errors
              });

            case 12:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutLinesUp = data.checkoutLinesUpdate) === null || _data$checkoutLinesUp === void 0 ? void 0 : _data$checkoutLinesUp.errors.length)) {
                _context5.next = 14;
                break;
              }

              return _context5.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutLinesUp2 = data.checkoutLinesUpdate) === null || _data$checkoutLinesUp2 === void 0 ? void 0 : _data$checkoutLinesUp2.errors
              });

            case 14:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutLinesUp3 = data.checkoutLinesUpdate) === null || _data$checkoutLinesUp3 === void 0 ? void 0 : _data$checkoutLinesUp3.checkout)) {
                _context5.next = 16;
                break;
              }

              return _context5.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutLinesUpdate.checkout)
              });

            case 16:
              _context5.next = 21;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", {
                error: _context5.t0
              });

            case 21:
              return _context5.abrupt("return", {});

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[4, 18]]);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.setShippingAddress =
  /*#__PURE__*/
  function () {
    var _ref8 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(shippingAddress, email, checkoutId) {
      var _shippingAddress$coun2, _data$checkoutEmailUp, _data$checkoutShippin, _data$checkoutShippin3, variables, _ref9, data, errors, _data$checkoutEmailUp2, _data$checkoutShippin2;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              variables = {
                checkoutId: checkoutId,
                email: email,
                shippingAddress: {
                  city: shippingAddress.city,
                  companyName: shippingAddress.companyName,
                  country: CountryCode[shippingAddress === null || shippingAddress === void 0 ? void 0 : (_shippingAddress$coun2 = shippingAddress.country) === null || _shippingAddress$coun2 === void 0 ? void 0 : _shippingAddress$coun2.code],
                  countryArea: shippingAddress.countryArea,
                  firstName: shippingAddress.firstName,
                  lastName: shippingAddress.lastName,
                  phone: shippingAddress.phone,
                  postalCode: shippingAddress.postalCode,
                  streetAddress1: shippingAddress.streetAddress1,
                  streetAddress2: shippingAddress.streetAddress2,
                  vatNumber: shippingAddress.vatNumber
                }
              };
              _context6.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutShippingAddressMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref9 = _context6.sent;
              data = _ref9.data;
              errors = _ref9.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutEmailUp = data.checkoutEmailUpdate) === null || _data$checkoutEmailUp === void 0 ? void 0 : _data$checkoutEmailUp.errors.length)) {
                _context6.next = 11;
                break;
              }

              return _context6.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutEmailUp2 = data.checkoutEmailUpdate) === null || _data$checkoutEmailUp2 === void 0 ? void 0 : _data$checkoutEmailUp2.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutShippin = data.checkoutShippingAddressUpdate) === null || _data$checkoutShippin === void 0 ? void 0 : _data$checkoutShippin.errors.length)) {
                _context6.next = 13;
                break;
              }

              return _context6.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutShippin2 = data.checkoutShippingAddressUpdate) === null || _data$checkoutShippin2 === void 0 ? void 0 : _data$checkoutShippin2.errors
              });

            case 13:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutShippin3 = data.checkoutShippingAddressUpdate) === null || _data$checkoutShippin3 === void 0 ? void 0 : _data$checkoutShippin3.checkout)) {
                _context6.next = 15;
                break;
              }

              return _context6.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutShippingAddressUpdate.checkout)
              });

            case 15:
              return _context6.abrupt("return", {});

            case 18:
              _context6.prev = 18;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", {
                error: _context6.t0
              });

            case 21:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 18]]);
    }));

    return function (_x8, _x9, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();

  this.setBillingAddress =
  /*#__PURE__*/
  function () {
    var _ref10 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(billingAddress, checkoutId) {
      var _billingAddress$count2, _data$checkoutBilling, _data$checkoutBilling3, variables, _ref11, data, errors, _data$checkoutBilling2;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              variables = {
                billingAddress: {
                  city: billingAddress.city,
                  companyName: billingAddress.companyName,
                  country: CountryCode[billingAddress === null || billingAddress === void 0 ? void 0 : (_billingAddress$count2 = billingAddress.country) === null || _billingAddress$count2 === void 0 ? void 0 : _billingAddress$count2.code],
                  countryArea: billingAddress.countryArea,
                  firstName: billingAddress.firstName,
                  lastName: billingAddress.lastName,
                  phone: billingAddress.phone,
                  postalCode: billingAddress.postalCode,
                  streetAddress1: billingAddress.streetAddress1,
                  streetAddress2: billingAddress.streetAddress2,
                  vatNumber: billingAddress.vatNumber
                },
                checkoutId: checkoutId
              };
              _context7.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutBillingAddressMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref11 = _context7.sent;
              data = _ref11.data;
              errors = _ref11.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutBilling = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling === void 0 ? void 0 : _data$checkoutBilling.errors.length)) {
                _context7.next = 11;
                break;
              }

              return _context7.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutBilling2 = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling2 === void 0 ? void 0 : _data$checkoutBilling2.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutBilling3 = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling3 === void 0 ? void 0 : _data$checkoutBilling3.checkout)) {
                _context7.next = 13;
                break;
              }

              return _context7.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutBillingAddressUpdate.checkout)
              });

            case 13:
              return _context7.abrupt("return", {});

            case 16:
              _context7.prev = 16;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", {
                error: _context7.t0
              });

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 16]]);
    }));

    return function (_x11, _x12) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.setNotes =
  /*#__PURE__*/
  function () {
    var _ref12 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(notes, checkoutId) {
      var _data$checkoutUpdateN, _data$checkoutUpdateN3, variables, _ref13, data, errors, _data$checkoutUpdateN2;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              variables = {
                checkoutId: checkoutId,
                deliveryNote: notes.deliveryNote,
                note: notes.note
              };
              _context8.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutNoteMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref13 = _context8.sent;
              data = _ref13.data;
              errors = _ref13.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context8.next = 9;
                break;
              }

              return _context8.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutUpdateN = data.checkoutUpdateNote) === null || _data$checkoutUpdateN === void 0 ? void 0 : _data$checkoutUpdateN.errors.length)) {
                _context8.next = 11;
                break;
              }

              return _context8.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutUpdateN2 = data.checkoutUpdateNote) === null || _data$checkoutUpdateN2 === void 0 ? void 0 : _data$checkoutUpdateN2.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutUpdateN3 = data.checkoutUpdateNote) === null || _data$checkoutUpdateN3 === void 0 ? void 0 : _data$checkoutUpdateN3.checkout)) {
                _context8.next = 13;
                break;
              }

              return _context8.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutUpdateNote.checkout)
              });

            case 13:
              return _context8.abrupt("return", {});

            case 16:
              _context8.prev = 16;
              _context8.t0 = _context8["catch"](0);
              return _context8.abrupt("return", {
                error: _context8.t0
              });

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 16]]);
    }));

    return function (_x13, _x14) {
      return _ref12.apply(this, arguments);
    };
  }();

  this.setBillingAddressWithEmail =
  /*#__PURE__*/
  function () {
    var _ref14 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9(billingAddress, email, checkoutId) {
      var _billingAddress$count3, _data$checkoutEmailUp3, _data$checkoutBilling4, _data$checkoutBilling6, variables, _ref15, data, errors, _data$checkoutEmailUp4, _data$checkoutBilling5;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              variables = {
                billingAddress: {
                  city: billingAddress.city,
                  companyName: billingAddress.companyName,
                  country: CountryCode[billingAddress === null || billingAddress === void 0 ? void 0 : (_billingAddress$count3 = billingAddress.country) === null || _billingAddress$count3 === void 0 ? void 0 : _billingAddress$count3.code],
                  countryArea: billingAddress.countryArea,
                  firstName: billingAddress.firstName,
                  lastName: billingAddress.lastName,
                  phone: billingAddress.phone,
                  postalCode: billingAddress.postalCode,
                  streetAddress1: billingAddress.streetAddress1,
                  streetAddress2: billingAddress.streetAddress2,
                  vatNumber: billingAddress.vatNumber
                },
                checkoutId: checkoutId,
                email: email
              };
              _context9.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutBillingAddressWithEmailMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref15 = _context9.sent;
              data = _ref15.data;
              errors = _ref15.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context9.next = 9;
                break;
              }

              return _context9.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutEmailUp3 = data.checkoutEmailUpdate) === null || _data$checkoutEmailUp3 === void 0 ? void 0 : _data$checkoutEmailUp3.errors.length)) {
                _context9.next = 11;
                break;
              }

              return _context9.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutEmailUp4 = data.checkoutEmailUpdate) === null || _data$checkoutEmailUp4 === void 0 ? void 0 : _data$checkoutEmailUp4.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutBilling4 = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling4 === void 0 ? void 0 : _data$checkoutBilling4.errors.length)) {
                _context9.next = 13;
                break;
              }

              return _context9.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutBilling5 = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling5 === void 0 ? void 0 : _data$checkoutBilling5.errors
              });

            case 13:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutBilling6 = data.checkoutBillingAddressUpdate) === null || _data$checkoutBilling6 === void 0 ? void 0 : _data$checkoutBilling6.checkout)) {
                _context9.next = 15;
                break;
              }

              return _context9.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutBillingAddressUpdate.checkout)
              });

            case 15:
              return _context9.abrupt("return", {});

            case 18:
              _context9.prev = 18;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", {
                error: _context9.t0
              });

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 18]]);
    }));

    return function (_x15, _x16, _x17) {
      return _ref14.apply(this, arguments);
    };
  }();

  this.setShippingMethod =
  /*#__PURE__*/
  function () {
    var _ref16 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10(shippingMethodId, checkoutId) {
      var _data$checkoutShippin4, _data$checkoutShippin6, _ref17, data, errors, _data$checkoutShippin5;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return _this.client.mutate({
                mutation: CheckoutMutations.updateCheckoutShippingMethodMutation,
                variables: {
                  checkoutId: checkoutId,
                  languageCode: _this.languageCode,
                  shippingMethodId: shippingMethodId
                }
              });

            case 3:
              _ref17 = _context10.sent;
              data = _ref17.data;
              errors = _ref17.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context10.next = 8;
                break;
              }

              return _context10.abrupt("return", {
                error: errors
              });

            case 8:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutShippin4 = data.checkoutShippingMethodUpdate) === null || _data$checkoutShippin4 === void 0 ? void 0 : _data$checkoutShippin4.errors.length)) {
                _context10.next = 10;
                break;
              }

              return _context10.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutShippin5 = data.checkoutShippingMethodUpdate) === null || _data$checkoutShippin5 === void 0 ? void 0 : _data$checkoutShippin5.errors
              });

            case 10:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutShippin6 = data.checkoutShippingMethodUpdate) === null || _data$checkoutShippin6 === void 0 ? void 0 : _data$checkoutShippin6.checkout)) {
                _context10.next = 12;
                break;
              }

              return _context10.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutShippingMethodUpdate.checkout)
              });

            case 12:
              return _context10.abrupt("return", {});

            case 15:
              _context10.prev = 15;
              _context10.t0 = _context10["catch"](0);
              return _context10.abrupt("return", {
                error: _context10.t0
              });

            case 18:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 15]]);
    }));

    return function (_x18, _x19) {
      return _ref16.apply(this, arguments);
    };
  }();

  this.addPromoCode =
  /*#__PURE__*/
  function () {
    var _ref18 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11(promoCode, checkoutId) {
      var _data$checkoutAddProm, _data$checkoutAddProm3, _ref19, data, errors, _data$checkoutAddProm2;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return _this.client.mutate({
                mutation: CheckoutMutations.addCheckoutPromoCode,
                variables: {
                  checkoutId: checkoutId,
                  languageCode: _this.languageCode,
                  promoCode: promoCode
                }
              });

            case 3:
              _ref19 = _context11.sent;
              data = _ref19.data;
              errors = _ref19.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context11.next = 8;
                break;
              }

              return _context11.abrupt("return", {
                error: errors
              });

            case 8:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutAddProm = data.checkoutAddPromoCode) === null || _data$checkoutAddProm === void 0 ? void 0 : _data$checkoutAddProm.errors.length)) {
                _context11.next = 10;
                break;
              }

              return _context11.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutAddProm2 = data.checkoutAddPromoCode) === null || _data$checkoutAddProm2 === void 0 ? void 0 : _data$checkoutAddProm2.errors
              });

            case 10:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutAddProm3 = data.checkoutAddPromoCode) === null || _data$checkoutAddProm3 === void 0 ? void 0 : _data$checkoutAddProm3.checkout)) {
                _context11.next = 12;
                break;
              }

              return _context11.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutAddPromoCode.checkout)
              });

            case 12:
              return _context11.abrupt("return", {});

            case 15:
              _context11.prev = 15;
              _context11.t0 = _context11["catch"](0);
              return _context11.abrupt("return", {
                error: _context11.t0
              });

            case 18:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 15]]);
    }));

    return function (_x20, _x21) {
      return _ref18.apply(this, arguments);
    };
  }();

  this.removePromoCode =
  /*#__PURE__*/
  function () {
    var _ref20 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12(promoCode, checkoutId) {
      var _data$checkoutRemoveP, _data$checkoutRemoveP3, _ref21, data, errors, _data$checkoutRemoveP2;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return _this.client.mutate({
                mutation: CheckoutMutations.removeCheckoutPromoCode,
                variables: {
                  checkoutId: checkoutId,
                  languageCode: _this.languageCode,
                  promoCode: promoCode
                }
              });

            case 3:
              _ref21 = _context12.sent;
              data = _ref21.data;
              errors = _ref21.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context12.next = 8;
                break;
              }

              return _context12.abrupt("return", {
                error: errors
              });

            case 8:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutRemoveP = data.checkoutRemovePromoCode) === null || _data$checkoutRemoveP === void 0 ? void 0 : _data$checkoutRemoveP.errors.length)) {
                _context12.next = 10;
                break;
              }

              return _context12.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutRemoveP2 = data.checkoutRemovePromoCode) === null || _data$checkoutRemoveP2 === void 0 ? void 0 : _data$checkoutRemoveP2.errors
              });

            case 10:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutRemoveP3 = data.checkoutRemovePromoCode) === null || _data$checkoutRemoveP3 === void 0 ? void 0 : _data$checkoutRemoveP3.checkout)) {
                _context12.next = 12;
                break;
              }

              return _context12.abrupt("return", {
                data: _this.constructCheckoutModel(data.checkoutRemovePromoCode.checkout)
              });

            case 12:
              return _context12.abrupt("return", {});

            case 15:
              _context12.prev = 15;
              _context12.t0 = _context12["catch"](0);
              return _context12.abrupt("return", {
                error: _context12.t0
              });

            case 18:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[0, 15]]);
    }));

    return function (_x22, _x23) {
      return _ref20.apply(this, arguments);
    };
  }();

  this.createPayment =
  /*#__PURE__*/
  function () {
    var _ref22 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13(amount, checkoutId, paymentGateway, paymentToken, billingAddress) {
      var _billingAddress$count4, _data$checkoutPayment, _data$checkoutPayment3, variables, _ref23, data, errors, _data$checkoutPayment2;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              variables = {
                checkoutId: checkoutId,
                paymentInput: {
                  amount: amount,
                  billingAddress: {
                    city: billingAddress.city,
                    companyName: billingAddress.companyName,
                    country: CountryCode[billingAddress === null || billingAddress === void 0 ? void 0 : (_billingAddress$count4 = billingAddress.country) === null || _billingAddress$count4 === void 0 ? void 0 : _billingAddress$count4.code],
                    countryArea: billingAddress.countryArea,
                    firstName: billingAddress.firstName,
                    lastName: billingAddress.lastName,
                    phone: billingAddress.phone,
                    postalCode: billingAddress.postalCode,
                    streetAddress1: billingAddress.streetAddress1,
                    streetAddress2: billingAddress.streetAddress2,
                    vatNumber: billingAddress.vatNumber
                  },
                  gateway: paymentGateway,
                  token: paymentToken
                }
              };
              _context13.next = 4;
              return _this.client.mutate({
                mutation: CheckoutMutations.createCheckoutPaymentMutation,
                variables: _objectSpread({}, variables, {
                  languageCode: _this.languageCode
                })
              });

            case 4:
              _ref23 = _context13.sent;
              data = _ref23.data;
              errors = _ref23.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context13.next = 9;
                break;
              }

              return _context13.abrupt("return", {
                error: errors
              });

            case 9:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutPayment = data.checkoutPaymentCreate) === null || _data$checkoutPayment === void 0 ? void 0 : _data$checkoutPayment.errors.length)) {
                _context13.next = 11;
                break;
              }

              return _context13.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutPayment2 = data.checkoutPaymentCreate) === null || _data$checkoutPayment2 === void 0 ? void 0 : _data$checkoutPayment2.errors
              });

            case 11:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutPayment3 = data.checkoutPaymentCreate) === null || _data$checkoutPayment3 === void 0 ? void 0 : _data$checkoutPayment3.payment)) {
                _context13.next = 13;
                break;
              }

              return _context13.abrupt("return", {
                data: _this.constructPaymentModel(data.checkoutPaymentCreate.payment)
              });

            case 13:
              return _context13.abrupt("return", {});

            case 16:
              _context13.prev = 16;
              _context13.t0 = _context13["catch"](0);
              return _context13.abrupt("return", {
                error: _context13.t0
              });

            case 19:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 16]]);
    }));

    return function (_x24, _x25, _x26, _x27, _x28) {
      return _ref22.apply(this, arguments);
    };
  }();

  this.completeCheckout =
  /*#__PURE__*/
  function () {
    var _ref24 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14(checkoutId) {
      var _data$checkoutComplet, _data$checkoutComplet3, _ref25, data, errors, _data$checkoutComplet2;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return _this.client.mutate({
                mutation: CheckoutMutations.completeCheckoutMutation,
                variables: {
                  checkoutId: checkoutId,
                  languageCode: _this.languageCode
                }
              });

            case 3:
              _ref25 = _context14.sent;
              data = _ref25.data;
              errors = _ref25.errors;

              if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
                _context14.next = 8;
                break;
              }

              return _context14.abrupt("return", {
                error: errors
              });

            case 8:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutComplet = data.checkoutComplete) === null || _data$checkoutComplet === void 0 ? void 0 : _data$checkoutComplet.errors.length)) {
                _context14.next = 10;
                break;
              }

              return _context14.abrupt("return", {
                error: data === null || data === void 0 ? void 0 : (_data$checkoutComplet2 = data.checkoutComplete) === null || _data$checkoutComplet2 === void 0 ? void 0 : _data$checkoutComplet2.errors
              });

            case 10:
              if (!(data === null || data === void 0 ? void 0 : (_data$checkoutComplet3 = data.checkoutComplete) === null || _data$checkoutComplet3 === void 0 ? void 0 : _data$checkoutComplet3.order)) {
                _context14.next = 12;
                break;
              }

              return _context14.abrupt("return", {
                data: _this.constructOrderModel(data.checkoutComplete.order)
              });

            case 12:
              return _context14.abrupt("return", {});

            case 15:
              _context14.prev = 15;
              _context14.t0 = _context14["catch"](0);
              return _context14.abrupt("return", {
                error: _context14.t0
              });

            case 18:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[0, 15]]);
    }));

    return function (_x29) {
      return _ref24.apply(this, arguments);
    };
  }();

  this.isLoggedIn = function () {
    return !!getAuthToken();
  };

  this.constructCheckoutModel = function (_ref26) {
    var id = _ref26.id,
        token = _ref26.token,
        email = _ref26.email,
        shippingAddress = _ref26.shippingAddress,
        billingAddress = _ref26.billingAddress,
        discount = _ref26.discount,
        discountName = _ref26.discountName,
        voucherCode = _ref26.voucherCode,
        lines = _ref26.lines,
        availableShippingMethods = _ref26.availableShippingMethods,
        shippingMethod = _ref26.shippingMethod,
        note = _ref26.note,
        deliveryNote = _ref26.deliveryNote;
    return {
      availableShippingMethods: availableShippingMethods ? availableShippingMethods.filter(filterNotEmptyArrayItems) : [],
      billingAddress: billingAddress,
      deliveryNote: deliveryNote,
      email: email,
      id: id,
      lines: lines === null || lines === void 0 ? void 0 : lines.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.quantity) && item.variant.id;
      }).map(function (item) {
        var _productAttributes;

        var itemVariant = item === null || item === void 0 ? void 0 : item.variant;
        return {
          id: item.id,
          productAttributes: (_productAttributes = item.productAttributes) === null || _productAttributes === void 0 ? void 0 : _productAttributes.map(function (attribute) {
            return {
              attributeId: attribute.attribute.id,
              name: attribute.attribute.name,
              values: attribute.values
            };
          }),
          quantity: item.quantity,
          totalPrice: item.totalPrice,
          variant: {
            attributes: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.attributes,
            id: itemVariant.id,
            isAvailable: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.isAvailable,
            name: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.name,
            pricing: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.pricing,
            product: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.product,
            quantityAvailable: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.quantityAvailable,
            sku: itemVariant === null || itemVariant === void 0 ? void 0 : itemVariant.sku
          }
        };
      }),
      note: note,
      promoCodeDiscount: {
        discount: discount,
        discountName: discountName,
        voucherCode: voucherCode
      },
      shippingAddress: shippingAddress,
      shippingMethod: shippingMethod,
      token: token
    };
  };

  this.constructPaymentModel = function (_ref27) {
    var id = _ref27.id,
        gateway = _ref27.gateway,
        token = _ref27.token,
        creditCard = _ref27.creditCard;
    return {
      creditCard: creditCard,
      gateway: gateway,
      id: id,
      token: token
    };
  };

  this.constructOrderModel = function (_ref28) {
    var id = _ref28.id,
        token = _ref28.token,
        orderNumber = _ref28.number;
    return {
      id: id,
      number: orderNumber,
      token: token
    };
  };

  this.client = client;
  this.languageCode = languageCode;
};